﻿import { Component, EventEmitter, Output} from "@angular/core";
import { Router} from "@angular/router";

@Component({
    selector: "cm-staffforgotPassword",
    templateUrl: "./StaffForgotPassword.Component.html",
})

export class StaffForgotPasswordComponent {

    constructor(private router: Router) {
    }

    login() {
        this.router.navigate(["/login"]);
    }
}
